module.exports = __webpack_public_path__ + "img/twitter_sample_image.c5bd1bf0.svg";